const filterType = Object.freeze({
  SEARCH: 1,
  REFBOOK: 2,
  SELECT: 3,
  CHECKBOX: 4,
  DATE: 5
})
export default filterType
